import { INumberStyle } from "./INumberStyle";

export interface INumberStyleSpecifiable {
  numberStyle: INumberStyle;
}

export function instanceOfINumberStyleSpecifiable(instance: any): instance is INumberStyleSpecifiable {
  return instance
      && (instance.numberStyle !== undefined);
}
